<template>
  <v-layout 
    wrap 
    align-start
    justify-start
    id="printBody"
    class="print-preview-body primary"
    ref="body">
    <v-container fluid class="pa-1 print-body">
      <v-flex shrink class="pageNum" v-if="!isPrinting">
        <v-btn
          text
          icon
          @click="changePage('left')"
          :disabled="currentPage == 1">
          <v-icon>fas fa-angle-left</v-icon>
        </v-btn>
        <span>Page {{this.printPreviewCurrentPage}} of {{this.pageNum}}</span>
        <v-btn 
          text
          icon
          @click="changePage('right')"
          :disabled="currentPage >= sheetNum">
          <v-icon>fas fa-angle-right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex class="print-body-pages-wrapper">
        <print-preview-images v-for="index in pageNum"
          v-bind:key="index"
          :images="printPreviewImages"
          :index="index"
          :isPrinting="isPrinting"
          :layout="layout"
          :pageNum="pageNum"/>
      </v-flex>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import tooltipGenerator from "../mixins/TooltipGenerator";
import printPreviewImages from "./PrintPreviewImages";

export default {
  name: "printPreviewBrowserBody",
  components: {printPreviewImages},
  mixins: [tooltipGenerator],
  computed: {
    ...mapGetters([
      "patient",
      "printPreviewContext",
      "printPreviewImages",
      "printPreviewDisplayHeader", 
      "printPreviewImagesPerSheet",
      "printPreviewCurrentPage",
      "printPreviewIsPrinting",
      "printPreviewPageLayout",
      "printPreviewSheetNum"
    ]),
    pageNum() {
      if (this.patient && this.printPreviewContext) {
        if (this.printPreviewSheetNum != Math.ceil(this.printPreviewImages.length / this.printPreviewImagesPerSheet))
          this.$store.commit("setPrintPreviewSheetNum", Math.ceil(this.printPreviewImages.length / this.printPreviewImagesPerSheet));
        return Math.ceil(this.printPreviewImages.length / this.printPreviewImagesPerSheet);
      }
      return 0;
    },
    isPrinting() {
      return this.printPreviewIsPrinting;
    },
    layout() {
      return this.printPreviewPageLayout;
    },
    currentPage() {
      return this.printPreviewCurrentPage;
    },
    sheetNum() {
      return this.printPreviewSheetNum;
    }
  },
  methods: {
    changePage(direction) {
      if (direction == "right")
        this.$store.commit("incrementPrintPreviewCurrentPage"); 
      else 
        this.$store.commit("decrementPrintPreviewCurrentPage");
    }
  }
}
</script>